module.exports = __webpack_public_path__ + "static/media/banner_real_socio.154d5e66.jpg";